import { SelectionBoxesCount, MarketTemplate } from "../../data";
export var mapSelectionNames = function (marketConfig, dict) {
    var selectionNames = [];
    var templateName = MarketTemplate[marketConfig.template];
    for (var i = 1; i <= SelectionBoxesCount[marketConfig.template]; i++) {
        var currentSelectionName = dict[templateName + "_" + marketConfig.idLive + "_" + i]
            || dict[templateName + "_" + marketConfig.idPreLive + "_" + i]
            || templateName + "_" + marketConfig.idLive + "_" + i;
        selectionNames.push(currentSelectionName);
    }
    return selectionNames;
};
//# sourceMappingURL=mapSelectionNames.js.map